module.exports = __webpack_public_path__ + "media/images/app_logo/apple-touch-icon-a25d396ae9e16e3c80dd2332e93015e4.png";